import { Drawer } from '@material-ui/core';
import styled from 'styled-components';

import { fontFamilySize, px } from '../../../../../../contrib/ui';

const drawerBleeding = 56;

export const StyledLeaderboardsDrawer = styled(Drawer)`
  .MuiPaper-root {
    overflow-y: unset;
    height: calc(100% - ${px(drawerBleeding)});
    overflow: visible;
  }

  .drawer-title {
    background: linear-gradient(
      0deg,
      #595959 0%,
      #000000 var(--bigButtonHeight),
      rgba(255, 255, 255, 0) var(--bigButtonHeight)
    );
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    left: 0px;
    position: absolute;
    right: 0px;
    top: -${drawerBleeding}px;
    visibility: visible;
    height: ${drawerBleeding}px;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    span {
      ${fontFamilySize('Bold', 20)}
    }

    .arrow-expand-less {
      position: absolute;
      right: ${px(10)};
      span {
        svg {
          color: #fff;
        }
      }
    }
  }

  .drawer-content {
    overflow-y: scroll;
  }
`;
